// Quill 기본 이미지 블롯은 src/alt만 보존하므로,
// quill-image-resize-module로 조정한 width/height/style(inline)이
// 저장→재편집(HTML 재파싱) 시 사라진다.
// width/height/style/alt 속성을 보존하는 커스텀 이미지 포맷을 전역 등록한다.
// (side-effect import: `import "utils/quillImageFormat";`)
import { Quill } from "react-quill";

const BaseImageFormat = Quill.import("formats/image");
const ATTRIBUTES = ["alt", "height", "width", "style"];

class ImageFormat extends BaseImageFormat {
  static formats(domNode) {
    return ATTRIBUTES.reduce((formats, attribute) => {
      if (domNode.hasAttribute(attribute)) {
        formats[attribute] = domNode.getAttribute(attribute);
      }
      return formats;
    }, {});
  }

  format(name, value) {
    if (ATTRIBUTES.indexOf(name) > -1) {
      if (value) {
        this.domNode.setAttribute(name, value);
      } else {
        this.domNode.removeAttribute(name);
      }
    } else {
      super.format(name, value);
    }
  }
}

// 두 번째 인자 true: 동일 이름("formats/image") 덮어쓰기 허용
Quill.register(ImageFormat, true);

export default ImageFormat;
